import React from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
} from "@mui/material";

import StandardButton from "../../../../components/StandardButton";

const MealPlanSelectDialog = ({ open, client, mealPlans, onClosed }) => {
  const [selectedMealPlan, setSelectedMealPlan] = React.useState(
    client.mealPlanId || null,
  );

  // Ensure mealPlans is always an array to prevent map errors
  const safeMealPlans = Array.isArray(mealPlans) ? mealPlans : [];

  function DisplayEmpty() {
    if (safeMealPlans.length === 0) {
      return (
        <MenuItem key={"none"} value="">
          There are no meal plans defined. Go to the Meals tab to define some.
        </MenuItem>
      );
    }
    return null;
  }

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      onClose={() => {
        if (onClosed) {
          onClosed();
        }
      }}
    >
      <DialogTitle>Select Meal Plan</DialogTitle>

      <DialogContent>
        <Box style={{ display: "flex", alignItems: "center", marginTop: 18 }}>
          <Typography style={{ width: 200 }}>Meal Plan:</Typography>
          <Select
            style={{ width: 512 }}
            variant="outlined"
            value={selectedMealPlan}
            onChange={(event) => {
              setSelectedMealPlan(event.target.value);
            }}
          >
            {<DisplayEmpty />}
            {safeMealPlans.map((mealPlan) => {
              return (
                <MenuItem key={mealPlan.id} value={mealPlan.id}>
                  {mealPlan.name}
                </MenuItem>
              );
            })}
          </Select>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (onClosed) {
              onClosed();
            }
          }}
          color="primary"
        >
          Cancel
        </Button>
        <StandardButton
          variant="primary"
          onClick={() => {
            if (onClosed) {
              onClosed(selectedMealPlan);
            }
          }}
        >
          Save
        </StandardButton>
      </DialogActions>
    </Dialog>
  );
};

export default MealPlanSelectDialog;
